import {
  jarallax,
  jarallaxElement,
} from '../../../../node_modules/jarallax';

// eslint-disable-next-line
import googlemaps from '../util/googlemaps';


export default {
  init() {
    jQuery('.hamburger').click(function () {
      jQuery(this).toggleClass('is-active');
      jQuery('.nav-primary').toggleClass('is-active');
      jQuery('html').toggleClass('no-scroll');
    });

    jQuery('.hover-effect').on('mouseover', function(e) {
      jQuery('.hover-effect').addClass('fadeout');
      e.currentTarget.addClass('active')
    }).on('mouseout', function(e) {
      jQuery('.hover-effect').removeClass('fadeout');
      e.removeClass('active')
    })

    jQuery('#gallery .btn').on('mouseover', function() {
      jQuery('#gallery').addClass('active');
    }).on('mouseout', function() {
      jQuery('#gallery').removeClass('active');
    })

    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 200,
            }, 750, function () {
              $('.hamburger').removeClass('is-active');
              $('.nav-primary').removeClass('is-active');
              $('html, body').removeClass('no-scroll');
            });
          }
        }
      });
  },
  finalize() {
    jQuery(window).scroll(function () {
      scrollHeader();
      initParallax();
    });

    if(jQuery('.slider')) {
      $('.slider').slick({
        arrows: true,
        fade: false,
        pauseOnHover: false,
        autoplay: false,
        speed: 750,
        autoplaySpeed: 3000,
        nextArrow: '<div class="arrow right"></div>',
        prevArrow: '<div class="arrow left"></div>',
      });
    }

    function scrollHeader() {
      if (jQuery('body').hasClass('template-pagebuilder')) {
        if (jQuery(document).scrollTop() < 40) {
          jQuery('a.brand').removeClass('small');
          jQuery('header').removeClass('small');
        } else {
          jQuery('a.brand').addClass('small');
          jQuery('header').addClass('small');
        }
      } else {
        if (jQuery(document).scrollTop() < window.outerHeight / 2) {
          jQuery('a.brand').removeClass('small');
          jQuery('header').removeClass('small');
        } else {
          jQuery('a.brand').addClass('small');
          jQuery('header').addClass('small');
        }
      }
    }

    function initParallax() {
      /*jQuery('.scroll-move.par-to-left').css('object-position', '-' + jQuery(document).scrollTop() / 3 + 'px');
      jQuery('.scroll-move.par-to-right').css('object-position', jQuery(document).scrollTop() / 3 + 'px');
      jQuery('.scroll-move.par-zoomOut').css('transform', 'scale(' + jQuery(document).scrollTop() / 1000 + ')');
      jQuery('.scroll-move.par-zoomIn').css('object-position', '-' + jQuery(document).scrollTop() / 3 + 'px');*/
    }

    jarallaxElement();
    // JavaScript to be fired on all pages, after page specific JS is fired
    jarallax(document.querySelectorAll('.jarallax'), {
      speed: 0.4,
      keepImg: false,
      type: 'scroll',
    });
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js